export default __webpack_public_path__ + "static/media/higher_primary_hi_ident_url_reversed.eff3b990.svg";